import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { GuidedSearchSetting } from '@interfaces/guided-search-setting.model';
import { MediaObserver } from '@ngbracket/ngx-layout';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { GuidedSearchService } from '@services/guided-search/guided-search.service';
import { setSearchMethodAction } from '@store/search/search.actions';
import { SearchMethods } from '@enums/search-methods.enum';
import { Store } from '@ngrx/store';
import { SearchState } from '@store/search/search.state';
import { CardEmphasis } from '@zelis/dls/card';

@Component({
  selector: 'app-guided-search-tile',
  templateUrl: './guided-search-tile.component.html',
  styleUrls: ['./guided-search-tile.component.scss'],
})
export class GuidedSearchTileComponent implements AfterViewInit, OnDestroy {
  @Input() category?: GuidedSearchSetting;
  @Input() cardIndex = 0;
  @Input() smartshopper?: boolean = false;
  @Input() showAllCategories?: boolean = false;
  @Input() loading?: boolean = false;

  @ViewChild('title') elementRef: ElementRef;

  public iconSize: string = 'lg';
  public selectedCategory: GuidedSearchSetting;
  public smartshopperEmphasis: CardEmphasis = {
    position: 'top',
    color: 'system-green',
  };

  private mediaSubscription: Subscription;

  constructor(
    private guidedSearchService: GuidedSearchService,
    private mediaQuery: MediaObserver,
    private store: Store<SearchState>
  ) {}

  ngAfterViewInit() {
    this.resizeTitle();
    this.mediaSubscription = this.subscribeToMediaChange();
  }

  ngOnDestroy() {
    this.mediaSubscription.unsubscribe();
  }

  public onTileClick(option: GuidedSearchSetting): void {
    const cardOrder = this.cardIndex + 1;

    this.store.dispatch(
      setSearchMethodAction({ searchMethod: SearchMethods.BrowseByCategory })
    );
    this.guidedSearchService.selectGuidedSearchOption(option, true, cardOrder);
  }

  private resizeTitle(): void {
    if (
      this.mediaQuery.isActive('gt-sm') &&
      !this.loading &&
      !this.showAllCategories &&
      this.elementRef.nativeElement.offsetHeight > 56
    ) {
      this.elementRef.nativeElement.classList.add('clamp', 'resize');
    }
  }

  private subscribeToMediaChange(): Subscription {
    return this.mediaQuery
      .asObservable()
      .pipe(filter(() => this.mediaQuery.isActive('gt-sm')))
      .subscribe(() => this.resizeTitle());
  }
}
